import React from 'react';
import Progress from "@/designSystem/Progress";
import { CompetitorMatchingDetails } from "../types";
import { getFactorColor } from "../utils/colors";

export const SimilarityBreakdown: React.FC<{
  matchingDetails: CompetitorMatchingDetails;
}> = ({ matchingDetails }) => {
  if (!matchingDetails?.contributions) return null;

  // Sort factors by contribution (highest first)
  const sortedContributions = Object.entries(matchingDetails.contributions)
    .sort(([_, a], [__, b]) => b - a)

  return (
    <div className="space-y-2 mb-1">
      {sortedContributions.map(([key, value]) => value === null ? null : (
        <div key={key} className="grid grid-cols-6 gap-2 items-center">
          <div className="col-span-1 text-xs text-gray-600 capitalize">
            {key.replace(/_/g, ' ')}:
          </div>
          <div className="col-span-4">
            <Progress
              value={value}
              className="h-1.5 bg-gray-200"
              indicatorClassName={getFactorColor(key)}
            />
          </div>
          <div className="col-span-1 text-xs text-gray-600 text-right">
            {value.toFixed(1)}%
          </div>
        </div>
      ))}
    </div>
  );
};